import { useStyletron } from 'baseui';
export const LegacyComponentContainer = ({
  children
}) => {
  const [css] = useStyletron();
  const hatched = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cline x1='0' y1='10' x2='10' y2='0' stroke='%23ffddaa' stroke-width='1'/%3E%3C/svg%3E")`,
    backgroundSize: '10px 10px',
    backgroundRepeat: 'repeat'
  };
  return <div className={css({
    margin: '1em',
    padding: '2em 3em',
    ...hatched,
    border: 'solid 4px rgba(255,186,0,0.1)'
  })}>
      {children}
    </div>;
};